import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Hero.css';
import ThreeBackground from './ThreeBackground';

const Hero = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        setIsLoggedIn(!!token);
    }, []);

    return (
        <div className="hero-container">
            <ThreeBackground />
            <div className="hero-overlay"></div>
            <div className="hero-content">
                <p className="hero-keywords">IoT · 피지컬 AI · 온디바이스 AI · 데이터 사이언스</p>
                <h1 className="hero-title">i2r IoT PLC & 센서</h1>
                <p className="hero-subtitle">IoT · 피지컬 AI · 온디바이스 AI 기반의 스마트 공장 자동화 솔루션</p>
                <div className="hero-btns">
                    {isLoggedIn ? (
                        <Link to="/overview" className="btn btn-primary">
                            대시보드 보기
                        </Link>
                    ) : (
                        <a href="#dashboard-preview" className="btn btn-primary">
                            대시보드 보기
                        </a>
                    )}
                    <a href="#products" className="btn btn-outline">
                        제품 살펴보기
                    </a>
                    <a href="https://github.com/kdi6033" target="_blank" rel="noreferrer" className="btn btn-outline">
                        문서 보기(GitHub)
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Hero;
